var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":"/tickets"}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":require("@src/assets/sidebar/tickets.svg")}})]),_c('router-link',{staticClass:"sub-menu-link",attrs:{"to":"/tickets"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('sidebar.tickets')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }